module.exports = __webpack_public_path__ + "static/img/product-swipe16.bd01de1b.png";